<template>
    <div>
        <div class>
            <Steps :active="4" :stepsShow=true align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-form
                    label-position="top"
                    label-width="180px"
                    :model="inServForm"
                    ref="inServForm"
                    :rules="dataRule"
                    size="small"
                    disabled>
                <el-row >
                    <el-col :span="6">
                        <!--价格(￥) -->
                        <el-form-item :label="$t('couse.courseprice')" prop="coursePrice">
                            <span slot="label">{{$t('couse.courseprice')}}
                              <el-tooltip placement="bottom-start" effect="light" >
                                <div slot="content">
                                  <p>为学员培训实际收取费用，请谨慎填写。</p>
                                  <p>若课程无需付费，课程价格填写为0；若课程需付费，课程价格=课程单价*标准时长（天）</p>
                                </div>
                                <em class="el-icon-question" style="color: #1C69D3"></em>
                              </el-tooltip>
                            </span>
                            <el-input v-model="inServForm.coursePrice"  ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <!-- 奖励积分 -->
                        <el-form-item :label="$t('couse.rewardscore') " >
                            <el-input v-model="inServForm.rewardScore" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <!-- 缺勤扣款(￥) -->
                        <el-form-item :label="$t('couse.noshowpenalty')" prop="noShowPenalty">
                            <span slot="label">{{$t('couse.noshowpenalty')}}
                              <el-tooltip placement="bottom-start" effect="light" >
                                <div slot="content">
                                  <p>1. 无需付费课程，缺勤扣款按照每年公布的No Show价格填写。</p>
                                  <p>2. 需付费课程，缺勤扣款按照课程价格填写，即缺勤扣款=价格。</p>
                                </div>
                                <em class="el-icon-question" style="color: #1C69D3"></em>
                              </el-tooltip>
                            </span>
                            <el-input v-model="inServForm.noShowPenalty"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <!-- 消费积分 -->
                        <el-form-item :label="$t('couse.consumptionscore')">
                            <el-input v-model.number="inServForm.consumptionScore"
                                      oninput="value=value.replace(/[^\d.]/g,'')"
                                      onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                      @keyup.native="consumptionScore"
                                      class="inputBox">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <!-- '预算号' -->
                        <el-form-item :label="$t('couse.budgetline')">
                            <el-input v-model="inServForm.budgetLine"
                                      class="inputBox">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('couse.whetherreturn')" prop="whetherReturn" style="display: block" disabled>
                            <span slot="label">{{$t('couse.whetherreturn')}}
                              <el-tooltip placement="bottom-start" effect="light" >
                                <div slot="content">
                                  学员通过课程后，返还学员报名时的排期价格。此字段不可编辑，发布后随课程中此字段的设置实时变化，最终取排期关课时的课程设置。
                                </div>
                                <em class="el-icon-question" style="color: #1C69D3"></em>
                              </el-tooltip>
                            </span>
                            <el-select v-model="inServForm.whetherReturn" disabled>
                                <el-option v-for="item in options"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="150">
                    <el-col :span="12">
                        <!-- '撤销报名发款' -->
                        <el-form-item :label="$t('couse.coureschex')">
                            <!-- <el-button type="info"
                                      @click="clickTest(inServForm.courseRevokePenaltyList)">{{$t('couse.couresadd')}}</el-button> -->
                <span slot="label">{{$t('couse.coureschex')}}
                  <el-tooltip placement="bottom-start" effect="light" >
                    <div slot="content">
                      需按照人员资质考核要求设定撤销报名扣款规则。
                    </div>
                    <em class="el-icon-question" style="color: #1C69D3"></em>
                  </el-tooltip>
                </span>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-table
                        :data="inServForm.offeringRevokePenaltyList"
                        stripe  class="spHeight"
                        :show-header="false"
                            border
                 style="width:600px">
                    <el-table-column label=""
                                     width="140">
                        <template slot-scope="scope">
                            <span >{{$t('couse.cousrq')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label=""
                                     align="center" header-align="center"
                                     width="130">
                        <template slot-scope="scope">
                            <el-form-item :prop="'offeringRevokePenaltyList.' + scope.$index + '.startDays'" class="rules"  :rules='dataRule.startDays'>
                                <el-input v-model="scope.row.startDays" class="el-inputs"
                                          oninput="value=value.replace(/[^\d.]/g,'')"
                                          onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label=""
                                     header-align="center"
                                     align="center"
                                     width="155">
                        <template slot-scope="scope" >
                            <span style="width: 155px;">{{$t('couse.couresday')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label=""
                                     header-align="center"
                                     align="center" >
                        <template slot-scope="scope" >
                            <el-col :span="20">
                                <el-form-item :prop="'offeringRevokePenaltyList.' + scope.$index + '.penaltyRate'" class="rules"  :rules='dataRule.penaltyRate'>
                                    <el-input
                                            v-model="scope.row.penaltyRate"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" style="line-height: 34px">
                                <span >%</span></el-col>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label=""
                                     width="100"
                                     header-align="center"
                                     align="center" >
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope.$index, inServForm.offeringRevokePenaltyList)"
                                       size="small"
                            > 删除 </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-form>
        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if = initIsShowEdit
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="btnSaveNextStep"
                           type="primary">{{ $t("course.next") }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {
    return {
      initIsShowEdit:'',
      dataForm: {
        offeringId: ''
      },
      inServForm: {
        whetherReturn: '',
        offeringId: '',
        courseId: '',
        coursePrice: '',
        rewardScore: '',
        noShowPenalty: '',
        consumptionScore: '',
        budgetLine: '',
        offeringRevokePenaltyList: []
      },
      options: [{
            value: '0',
            label: '不返还'
        }, {
            value: '1',
            label: '返还'
        }],
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      return {
        penaltyRate: [ { type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }, {
          validator (rule, value, callback) {
            if (/(^[0-9]+(\.[0-9]{0,2})?$)/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入正确的罚款比例(保留两位小数'))
            }
          },
          trigger: 'blur'
        }],
        startDays: [ { type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }, {
          validator (rule, value, callback) {
            // if (/^(-)?(0|[1-9](\d)*)(\.(\d)+)?%$/.test(value)) {
            if (/(^[0-9]+(\.[0-9]{0})?$)/.test(value)) {
              callback()
            } else {
              // callback(new Error('请输入正确的百分数'))
              callback(new Error('请输入正确的整数'))
            }
          },
          trigger: 'blur'
        }],
        // 价格
        rewardscore: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 缺勤扣款
        noShowPenalty: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { type: 'number',
            message: '请输入数字格式',
            trigger: 'blur',
            transform (value) {
              return Number(value)
            } }, {
            validator (rule, value, callback) {
              if (/(^[0-9]+(\.[0-9]{0,2})?$)/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的缺勤扣款(保留两位小数)'))
              }
            },
            trigger: 'blur'
          }],
        // 奖励积分
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { type: 'number',
            message: '请输入数字格式',
            trigger: 'blur',
            transform (value) {
              return Number(value)
            } }, {
            validator (rule, value, callback) {
              if (/(^[0-9]+(\.[0-9]{0,2})?$)/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的价格(保留两位小数)'))
              }
            },
            trigger: 'blur'
          }],
          whetherReturn: [
              { required: true, message: this.$t('validate.required'), trigger: 'blur' }]

      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      this.init(this.$route.query.offeringId)
    }
      if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
          this.initIsShowEdit = this.$route.query.isShowEdit
      }
  },
  // 方法集合
  methods: {
    sendEdit(){
       console.log("sendEdit")
       this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    // 设置初始化为空
    again () {
      this.inServForm.offeringId = ''
      this.inServForm.courseId = ''
      this.inServForm.coursePrice = ''
      this.inServForm.rewardScore = ''
      this.inServForm.noShowPenalty = ''
      this.inServForm.consumptionScore = ''
      this.inServForm.budgetLine = ''
      this.inServForm.offeringRevokePenaltyList = []
    },
    // 初始化数据
    init (offeringId) {
      this.again()
      this.getOfferingPrice()
    },
    // 初始化数据
    getOfferingPrice () {
        this.dataForm.offeringId = this.$route.query.offeringId
      this.inServForm.offeringId = this.$route.query.offeringId
      if (this.inServForm.offeringId === null || this.inServForm.offeringId === '') {
        return
      }
      this.$request.get('/learning/base/offeringinfo/get/' + this.inServForm.offeringId
      ).then((res, total, code, data) => {
        if (data.data !== undefined && data.data !== null) {
          this.inServForm = data.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存方法
    btnSave () {
      // TODO 成功调用  this.sendSave()
    },
    // 保存并下一步
    btnSaveNextStep () {
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 添加撤销报名规则
    clickTest (tableData, event) {
      tableData.push({ startDays: '', penaltyRate: '' })
    },
    // 删除撤销报名规则
    deleteRow (index, rows) { // 删除改行
      rows.splice(index, 1)
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offinvestsend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offinvestSave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
 .el-inputs {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100px;
}

    /* <style scoped> */
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    .el-row {
        margin-bottom: 20px;
    }

    .div {
        padding-right: 10px;
        overflow: initial;
        text-overflow: ellipsis;
    }
    .cell {
        padding-right: 10px;
        overflow: initial;
        text-overflow: ellipsis;
    }
    .spHeight td{
        height: 23px;
    }
    /* .el-form-item__error{color:#F56C6C;font-size:12px;line-height:1;padding-top:4px;position:absolute;top:100%;left:0} */
    .el-form-item__error{color:#F56C6C;font-size:12px;line-height:1;padding-top:4px;position:relative;top:100%;left:0}
    /* .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: relative;
        top: 100%;
        left: 0;
    } */
    .el-table th div {
        padding-right: 10px;
        overflow: initial;
        text-overflow: ellipsis;
    }

    .el-table .cell, .el-table th div {
        padding-right: 10px;
        overflow: initial;
        text-overflow: ellipsis;
    }

</style>
